import React, { FC } from 'react';
import { HStack, Icon, Text, Tooltip } from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';

interface LTextProps {
  center?: boolean;
  title: string;
  color?: string;
  info?: string;
}

const TextLabel: FC<LTextProps> = ({
  title,
  center = false,
  color = 'gray.500',
  info = '',
}) => (
  <HStack align='center'>
    <Text
      fontSize='sm'
      fontWeight='medium'
      textAlign={center ? 'center' : 'left'}
      color={color}
    >
      {title}
    </Text>
    {!!info && (
      <Tooltip label={info} closeDelay={1000}>
        <HStack>
          <Icon as={FiInfo} color='gray.500' />
        </HStack>
      </Tooltip>
    )}
  </HStack>
);

export default TextLabel;
